import React from "react";
import { useNavigate } from "react-router-dom";

const PersonalisedBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-manageBookBanner py-20 flex items-center justify-center">
      <div className="flex flex-col lg:flex-row items-center p-8 rounded-lg max-w-4xl">
        <div className=" relative w-auto h-auto rounded-[50%] overflow-hidden mb-8 lg:mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/assets/manageBookings/personalisedBanner.png`}
            package
            alt="Dancing on the deck"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="text-center lg:text-left lg:ml-8">
          <h2 className="text-3xl font-bold text-mv-darkblue mb-4">
            CREATE YOUR PERSONAL PARADISE
          </h2>
          <p className="text-mv-darkblue font-semibold mb-6">
            Get the most out of your Margaritaville at Sea getaway with one (or
            more!) of our add-on packages. From specialty dining to Wi-Fi, we
            have you covered with everything you’ll need to maximize your chill.
          </p>
          <button
            onClick={() => navigate("./?currentTab=Enhance Sailing")}
            className="bg-mv-darkblue text-white py-2 px-4 shadow-md hover:bg-blue-700 transition duration-300"
          >
            ENHANCE YOUR SAILING
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalisedBanner;
